import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { forwardRef } from "react";
import { type TypographyProps } from "@mui/material";
import ProductMMD from "./ProductMMD";

type Props = BaseProductElementProps & Omit<TypographyProps, "children">;

export const MMDChip = forwardRef<HTMLElement, Props>((props, ref) => {
  const product = useProductContext(props);

  if (!product.marketDesignation) {
    return null;
  }

  return <ProductMMD marketDesignation={product.marketDesignation} />;
});
